(() => {
  'use strict';

  const root = document.getElementById('tt-order-tracking');
  if (!root || root.dataset.initialized === 'true') return;
  const get = id => root.querySelector(`#tt-${id}`);
  const form = get('tracking-form');
  const input = get('tracking-query');
  const result = get('tracking-result');
  const live = get('tracking-live');
  const button = get('track-button');
  const errorMessage = get('search-error');
  const whatsappHelp = get('whatsapp-help');
  const model = window.TTTrackingModel;
  const client = window.TTLionExClient;
  if (!form || !input || !result || !live || !button || !errorMessage || !model || !client) return;
  let dictionary;
  try {
    dictionary = JSON.parse(root.querySelector('[data-tt-tracking-copy]').textContent);
  } catch {
    return;
  }
  root.dataset.initialized = 'true';

  const translate = (key, values = {}) => String(dictionary[key] || '').replace(/\[\[([a-z_]+)\]\]/g, (match, name) => Object.hasOwn(values, name) ? String(values[name]) : match);
  const escape = value => String(value ?? '').replace(/[&<>"']/g, char => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[char]));
  const rawLocale = root.dataset.locale || document.documentElement.lang || 'en-GB';
  let locale = rawLocale === 'en' ? 'en-GB' : rawLocale;
  try {
    new Intl.DateTimeFormat(locale);
  } catch {
    locale = 'en-GB';
  }
  const whatsapp = (root.dataset.whatsapp || '').replace(/\D/g, '');
  const paths = {
    booked: '<path d="m3 7 9-5 9 5v10l-9 5-9-5V7Z"/><path d="m3 7 9 5 9-5M12 12v10M7.5 4.5l9 5"/>',
    transit: '<path d="M2 5h13v12H2zM15 9h4l3 4v4h-7"/><circle cx="6" cy="18" r="2"/><circle cx="18" cy="18" r="2"/><path d="M8 18h8"/>',
    at_destination: '<path d="m3 10 9-7 9 7v11H3V10Z"/><path d="M8 21v-9h8v9M3 10h18M8 16h8"/>',
    out_for_delivery: '<path d="M2 5h13v12H2zM15 9h4l3 4v4h-7"/><circle cx="6" cy="18" r="2"/><circle cx="18" cy="18" r="2"/><path d="m5 10 3 3 4-5"/>',
    issue: '<circle cx="12" cy="12" r="9"/><path d="M12 7v6M12 16v1"/>',
    return: '<path d="M8 5 3 10l5 5M3 10h10a7 7 0 1 1 0 14" transform="translate(0 -2)"/>',
    delivered: '<circle cx="12" cy="12" r="9"/><path d="m7 12 3 3 7-7"/>',
    unknown: '<circle cx="12" cy="12" r="9"/><path d="M12 10v7M12 7v1"/>',
    search: '<circle cx="10.5" cy="10.5" r="6.5"/><path d="m15.5 15.5 4.5 4.5"/>',
    unavailable: '<path d="M3 7a15 15 0 0 1 18 0M6 11a10 10 0 0 1 12 0M9 15a5 5 0 0 1 6 0M12 19h.01M3 3l18 18"/>'
  };
  const icon = key => `<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">${paths[key] || paths.unknown}</svg>`;
  let request = 0;
  let currentQuery = '';
  let currentCourier = '';
  let activeController = null;

  function fetchedLabel(value) {
    const date = new Date(value);
    if (!Number.isFinite(date.getTime())) return translate('fetch_time_unavailable');
    const formatted = new Intl.DateTimeFormat(locale, { timeZone: 'Asia/Karachi', day: 'numeric', month: 'short', year: 'numeric', hour: 'numeric', minute: '2-digit', hour12: true }).format(date);
    return translate('fetched_on', { date: formatted });
  }

  function helpUrl(query) {
    return `https://wa.me/${whatsapp}?text=${encodeURIComponent(translate(query ? 'whatsapp_message' : 'whatsapp_message_empty', { number: query }))}`;
  }

  function setHelp(query) {
    if (whatsappHelp && whatsapp) whatsappHelp.href = helpUrl(query);
  }

  function eventMarkup(event, index) {
    return `<li class="tracking-event ${index === 0 ? 'latest' : ''}"><span class="event-dot" aria-hidden="true"></span><div class="event-content"><div class="event-header"><p class="event-title" title="${escape(event.raw)}">${escape(event.title)}</p><time class="event-date"${event.iso ? ` datetime="${escape(event.iso)}"` : ''}>${escape(event.full)}</time></div>${event.reason ? `<p class="event-description">${escape(translate('courier_note', { note: event.reason }))}</p>` : ''}</div></li>`;
  }

  function shipmentMarkup(record) {
    const data = model.normalizeShipment(record, { translate, locale });
    const visible = data.events.slice(0, 4);
    const older = data.events.slice(4);
    return `<section class="result-card" data-status="${escape(data.state)}" aria-labelledby="tt-result-title"><div class="result-notice">${escape(fetchedLabel(record.fetched_at))}</div><div class="result-top"><span class="status-symbol">${icon(data.state)}</span><div class="status-copy"><h2 id="tt-result-title" class="status-title" tabindex="-1">${escape(data.title)}</h2><p class="status-description">${escape(data.description)}</p></div></div><dl class="shipment-info"><div class="meta-item"><dt class="meta-label">${escape(translate('tracking_number'))}</dt><dd class="meta-value">${escape(data.tracking)}</dd></div><div class="meta-item"><dt class="meta-label">${escape(translate('courier'))}</dt><dd class="meta-value">${escape(data.partner || translate('not_specified'))}</dd></div><div class="meta-item"><dt class="meta-label">${escape(translate('latest_update'))}</dt><dd class="meta-value">${escape(data.latest.date)}</dd><dd class="meta-help">${escape(data.latest.time)}</dd></div></dl><section class="history-section" aria-labelledby="tt-history-title"><div class="panel-heading"><h3 id="tt-history-title">${escape(translate('tracking_history'))}</h3><span>${escape(translate('latest_first'))}</span></div><ol class="tracking-events">${visible.map(eventMarkup).join('')}</ol>${older.length ? `<details class="older-events"><summary>${escape(translate(older.length === 1 ? 'earlier_update' : 'earlier_updates', { count: older.length }))}</summary><ol class="tracking-events">${older.map((event, index) => eventMarkup(event, index + 4)).join('')}</ol></details>` : ''}</section><div class="result-footer"><p class="source-time-note">${escape(translate('times_as_reported'))}</p></div></section>`;
  }

  function alertMarkup(key, query) {
    const states = {
      unavailable: { title: 'unavailable_title', body: 'unavailable_body', icon: 'unavailable', action: 'retry', label: 'retry' },
      notfound: { title: 'notfound_title', body: 'notfound_body', icon: 'search', action: 'retry', label: 'retry' },
      invalid_reference: { title: 'invalid_title', body: 'invalid_body', icon: 'search', action: 'focus', label: 'check_number' }
    };
    const state = states[key] || states.unavailable;
    return `<section class="result-card" aria-labelledby="tt-result-title"><div class="result-notice">${escape(translate('lookup_notice'))}</div><div class="alert-state"><span class="alert-icon">${icon(state.icon)}</span><div class="alert-content"><h2 id="tt-result-title" tabindex="-1">${escape(translate(state.title))}</h2><p>${escape(translate(state.body))}</p>${query ? `<p class="alert-reference">${escape(translate('reference'))}: <strong>${escape(query)}</strong></p>` : ''}<button class="text-link inline-action" type="button" data-tt-action="${state.action}">${escape(translate(state.label))}</button></div></div></section>`;
  }

  function resetValidation() {
    errorMessage.hidden = true;
    input.removeAttribute('aria-invalid');
  }

  function setButton(loading) {
    button.disabled = loading;
    const label = button.querySelector('span');
    if (label) label.textContent = translate(loading ? 'loading_button' : 'track_order');
  }

  function render(key, query = '', record = null, focus = false) {
    currentQuery = query;
    input.value = query;
    result.setAttribute('aria-busy', 'false');
    setButton(false);
    setHelp(query);
    resetValidation();
    if (key === 'empty') {
      result.innerHTML = '';
      result.hidden = true;
      live.textContent = translate('enter_number');
      return;
    }
    result.hidden = false;
    result.innerHTML = record ? shipmentMarkup(record) : alertMarkup(key, query);
    const title = get('result-title');
    live.textContent = translate(record ? 'loaded_announcement' : 'lookup_announcement', { title: title?.textContent || '' });
    if (focus) title?.focus({ preventScroll: true });
  }

  function writeUrl(query, replace = false) {
    const url = new URL(location.href);
    url.searchParams.delete('tracking');
    if (query) url.searchParams.set('t', query);
    else url.searchParams.delete('t');
    if (currentCourier === 'prime') url.searchParams.set('courier', 'prime');
    else url.searchParams.delete('courier');
    history[replace ? 'replaceState' : 'pushState']({}, '', url);
  }

  function cancelPending() {
    ++request;
    activeController?.abort();
    activeController = null;
  }

  function showLoading(query) {
    resetValidation();
    input.value = query;
    setHelp(query);
    result.hidden = false;
    result.setAttribute('aria-busy', 'true');
    setButton(true);
    result.innerHTML = `<div class="loading-state"><span class="spinner" aria-hidden="true"></span><p>${escape(translate('loading_details'))}</p></div>`;
    live.textContent = translate('loading_announcement');
  }

  async function lookup(query, { updateUrl = true, focus = true, courier = currentCourier } = {}) {
    cancelPending();
    const token = request;
    currentQuery = query;
    currentCourier = courier === 'prime' ? 'prime' : '';
    if (updateUrl) writeUrl(query);
    try {
      showLoading(query);
      activeController = new AbortController();
      const record = await client.lookupTracking(query, { signal: activeController.signal,
        traxEndpoint: root.dataset.traxEndpoint, primeEndpoint: root.dataset.primeEndpoint, courier: currentCourier });
      if (token !== request) return;
      if (updateUrl && record.tracking !== query) writeUrl(record.tracking, true);
      render('live', record.tracking, record, focus);
    } catch (error) {
      if (token !== request) return;
      render(['notfound', 'invalid_reference'].includes(error.code) ? error.code : 'unavailable', query, null, focus);
    } finally {
      if (token === request) activeController = null;
    }
  }

  form.addEventListener('submit', event => {
    event.preventDefault();
    const query = input.value.trim();
    if (!query) {
      cancelPending();
      currentQuery = '';
      currentCourier = '';
      result.innerHTML = '';
      result.hidden = true;
      result.setAttribute('aria-busy', 'false');
      setButton(false);
      setHelp('');
      errorMessage.textContent = translate('enter_number');
      errorMessage.hidden = false;
      input.setAttribute('aria-invalid', 'true');
      input.focus();
      live.textContent = translate('enter_number');
      return;
    }
    lookup(query);
  });

  input.addEventListener('input', () => {
    cancelPending();
    currentQuery = '';
    currentCourier = '';
    result.innerHTML = '';
    result.hidden = true;
    setButton(false);
    setHelp('');
    resetValidation();
    result.setAttribute('aria-busy', 'false');
    live.textContent = '';
  });

  result.addEventListener('click', event => {
    const action = event.target.closest('[data-tt-action]')?.dataset.ttAction;
    if (action === 'focus') input.focus();
    if (action === 'retry' && currentQuery) lookup(currentQuery, { updateUrl: false });
  });

  function readUrl() {
    cancelPending();
    const params = new URLSearchParams(location.search);
    const query = (params.get('t') || params.get('tracking') || '').trim();
    currentCourier = (params.get('courier') || '').trim().toLowerCase() === 'prime' ? 'prime' : '';
    if (query) lookup(query, { updateUrl: false, focus: false });
    else render('empty');
  }

  window.addEventListener('popstate', readUrl);
  window.addEventListener('pagehide', cancelPending);
  window.addEventListener('pageshow', event => { if (event.persisted) readUrl(); });
  readUrl();
})();

